import {
  JsonPipe,
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
} from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Product } from 'src/app/classes/utility';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-image-gallery',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgFor,
    NgIf,
    NgClass,
    CarouselComponent,
    JsonPipe,
  ],
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss',
})
export class ImageGalleryComponent implements OnChanges {
  @Input() product!: Product;
  _media!: any;
  _selectedVariant: any;
  _medias: any[] | undefined;
  options = {
    0: { slides: 1, nav: false },
  };
  constructor(private productService: ProductService) {}

  ngOnChanges() {
    this.productService.variantObservable.subscribe((data) => {
      this._selectedVariant = data;
      delete this._medias;
      try {
        if (
          this.product.media.find((x: any) =>
            x?.alt?.includes(this._selectedVariant.title)
          )
        ) {
          this._medias = this.product.media.filter(
            (x: any) =>
              (x.alt || '').includes(this._selectedVariant.title) || !x.alt
          );
          if (this._medias?.length === 0) delete this._medias;
        }

        this._media =
          (this._medias || this.product.media).find(
            (x: any) => x.id == data.image_id
          ) || this._media;
      } catch (err) {
        console.log(err);
      }

      try {
        this._media =
          (this._medias || this.product.media).find(
            (x: any) => x.id == data.image_id
          ) || this._media;
      } catch (err) {
        console.log(err);
      }
      this._media = (this._medias || this.product.media)[0];
    });
  }
}
